<template>
  <div class="route">
    <div class="form-section legs">
      <div v-for="(leg, i) in route" :key="leg.key" class="form-break">
        <div class="form-row options">
          <select class="sml" aria-label="Number of Rooms" @change="roomsUpdate(i, $event.target.value)">
            <option v-for="n in 8" :key="n" :value="n" :selected="n == leg.rooms.length">{{ n }} {{ n == 1 ? "Room" : "Rooms" }}</option>
          </select>
          <select v-for="(room, j) in leg.rooms" :key="j" v-model="room.adults" class="sml" aria-label="Number of Adults">
            <option v-for="n in 8" :key="n" :value="n">{{ n }} {{ n == 1 ? "Adult" : "Adults" }}</option>
          </select>
        </div>
        <div class="form-row leg">
          <PlacePicker v-model:place="leg.place" :placeholder="'Place'" @error="emit('error', $event)" />
          <div class="break" />
          <DatePicker v-model:date="leg.checkin" class="checkin" :placeholder="'Check-In'" @error="emit('error', $event)" />
          <div class="break dates" />
          <DatePicker v-model:date="leg.checkout" class="checkout" :min="leg.checkin" :placeholder="'Check-Out'" />
          <a v-if="route.length > 1" class="remove" @click="legRemove(i)">&cross;</a>
        </div>
      </div>
      <div class="add">
        <a @click="legAdd">Add Hotel</a>
      </div>
    </div>
    <div id="navigation">
      <button @click="next">Next Step</button>
      <a @click="back">Back</a>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import DatePicker from "./common/PickerDate.vue";
import PlacePicker from "./common/PickerPlace.vue";

const emit = defineEmits(["error", "back", "update:hotels", "update:isSavedRoute", "update:legIndex", "scroll"]);

const props = defineProps({
  hotels: Object,
});

const route = ref(props.hotels.route);

const back = () => {
  emit("back");
};

const blank = () => {
  const key = props.hotels.route.length + 1;
  return new (function Leg(key) {
    this.key = key;
    this.checkin = "";
    this.checkout = "";
    this.ideal = {};
    this.place = "";
    this.rooms = [{ adults: 1 }];
  })(key);
};

const legAdd = () => {
  route.value.push(blank());
};

const legRemove = index => {
  route.value.splice(index, 1);
};

const next = () => {
  let validated = true;
  for (let i = 0; i < route.value.length; i++) {
    if (!route.value[i].checkin || !route.value[i].checkout || !route.value[i].place) {
      validated = false;
    }
  }

  if (validated === false) {
    alert("Please select locations and dates for all hotels before continuing.");
  } else {
    route.value.forEach(leg => {
      leg.ideal = {};
    });

    const newHotels = props.hotels;
    newHotels.route = route.value;

    emit("update:hotels", newHotels);
    emit("update:isSavedRoute", true);
    emit("update:legIndex", 0);
    emit("scroll");
  }
};

const roomsUpdate = (legIndex, rooms) => {
  const newHotels = props.hotels;
  const len = newHotels.route[legIndex].rooms.length;
  const diff = rooms - len;

  if (diff > 0) {
    for (let i = 0; i < diff; i++) {
      newHotels.route[legIndex].rooms.push({ adults: 1 });
    }
  } else if (diff < 0) {
    newHotels.route[legIndex].rooms.splice(0, -diff);
  }

  emit("update:hotels", newHotels);
};
</script>

<style lang="less">
#hotels {
  .route {
    clear: both;
  }

  .leg {
    flex-wrap: wrap;
  }

  .form-break {
    margin-bottom: 1rem;
  }

  .options {
    margin-bottom: 1rem;
  }

  .pax {
    display: flex;

    span {
      align-self: center;
      padding-right: 1rem;
    }
  }

  .picker,
  .date-picker {
    flex: 1;
  }

  .break {
    flex-basis: 100%;
    height: 0;
  }

  .remove {
    background: none;
    border: none;
    padding: 1rem 0;
    text-align: right;
    width: 2rem;
  }
}

@media screen and (min-width: 22.5em) {
  #hotels {
    .checkin {
      margin-right: 1rem;
    }

    .break.dates {
      display: none;
    }
  }
}

@media screen and (min-width: 30em) {
  #hotels {
    .options {
      select {
        flex: 1;
        margin-right: 1rem;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .leg {
      display: flex;
      flex-wrap: wrap;
    }
  }
}

@media screen and (min-width: 60em) {
  #hotels {
    .options {
      select {
        flex: none;
      }
    }

    .picker,
    .checkin {
      margin-right: 1rem;

      &:last-child {
        margin-right: 0;
      }
    }

    .break {
      display: none;
    }
  }
}
</style>
